import React from 'react';

const Footer = () => {
    return (
        <footer className="border-t-3 border-indigo-500 w-full p-4 bg-gray-800 shadow md:flex md:items-center md:justify-between md:p-6 text-center mt-auto">
            <span className="text-sm text-white font-bold text-black sm:text-center dark:text-gray-400 flex justify-center">
                Copyright © 2023. All rights are reserved
            </span>
        </footer>
    );
};

export default Footer;